import React from "react";
import PropTypes from "prop-types";
import "./inactivity-warning.css";

const InactivityWarning = ({ 
  isVisible, 
  countdown, 
  onExtendSession, 
  onLogoutNow 
}) => {
  if (!isVisible) return null;

  return (
    <div className="inactivity-warning-overlay">
      <div className="inactivity-warning-modal">
        <div className="inactivity-warning-header">
          <h3>Session Expiring</h3>
        </div>
        <div className="inactivity-warning-body">
          <p>You will be logged out due to inactivity in:</p>
          <div className="countdown-display">
            <span className="countdown-number">{countdown}</span>
            <span className="countdown-text">seconds</span>
          </div>
          <p>Would you like to extend your session?</p>
        </div>
        <div className="inactivity-warning-actions">
          <button 
            className="btn btn-primary extend-session-btn"
            onClick={onExtendSession}
          >
            Extend Session
          </button>
          <button 
            className="btn btn-secondary logout-now-btn"
            onClick={onLogoutNow}
          >
            Logout Now
          </button>
        </div>
      </div>
    </div>
  );
};

InactivityWarning.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  countdown: PropTypes.number.isRequired,
  onExtendSession: PropTypes.func.isRequired,
  onLogoutNow: PropTypes.func.isRequired,
};

export default InactivityWarning;